/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */
import { useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type {
  GetIncidentsParams,
  HTTPValidationError,
  IncidentDetailGetResponse,
  IncidentsGetResponseSchema,
} from '../../schemas';

import { customInstance } from '../../../utils/apiClient';

/**
 * @summary 事案一覧取得
 */
export const getIncidents = (
  params?: GetIncidentsParams,
  signal?: AbortSignal
) => {
  return customInstance<IncidentsGetResponseSchema>({
    url: `/incidents`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetIncidentsQueryKey = (params?: GetIncidentsParams) => {
  return [`/incidents`, ...(params ? [params] : [])] as const;
};

export const getGetIncidentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getIncidents>>,
  TError = HTTPValidationError,
>(
  params?: GetIncidentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getIncidents>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetIncidentsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getIncidents>>> = ({
    signal,
  }) => getIncidents(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getIncidents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetIncidentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getIncidents>>
>;
export type GetIncidentsQueryError = HTTPValidationError;

export function useGetIncidents<
  TData = Awaited<ReturnType<typeof getIncidents>>,
  TError = HTTPValidationError,
>(
  params: undefined | GetIncidentsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getIncidents>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIncidents>>,
          TError,
          Awaited<ReturnType<typeof getIncidents>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetIncidents<
  TData = Awaited<ReturnType<typeof getIncidents>>,
  TError = HTTPValidationError,
>(
  params?: GetIncidentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getIncidents>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIncidents>>,
          TError,
          Awaited<ReturnType<typeof getIncidents>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetIncidents<
  TData = Awaited<ReturnType<typeof getIncidents>>,
  TError = HTTPValidationError,
>(
  params?: GetIncidentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getIncidents>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary 事案一覧取得
 */

export function useGetIncidents<
  TData = Awaited<ReturnType<typeof getIncidents>>,
  TError = HTTPValidationError,
>(
  params?: GetIncidentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getIncidents>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetIncidentsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetIncidentsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getIncidents>>,
  TError = HTTPValidationError,
>(
  params?: GetIncidentsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getIncidents>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetIncidentsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getIncidents>>> = ({
    signal,
  }) => getIncidents(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getIncidents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetIncidentsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getIncidents>>
>;
export type GetIncidentsSuspenseQueryError = HTTPValidationError;

export function useGetIncidentsSuspense<
  TData = Awaited<ReturnType<typeof getIncidents>>,
  TError = HTTPValidationError,
>(
  params: undefined | GetIncidentsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getIncidents>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetIncidentsSuspense<
  TData = Awaited<ReturnType<typeof getIncidents>>,
  TError = HTTPValidationError,
>(
  params?: GetIncidentsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getIncidents>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetIncidentsSuspense<
  TData = Awaited<ReturnType<typeof getIncidents>>,
  TError = HTTPValidationError,
>(
  params?: GetIncidentsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getIncidents>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
/**
 * @summary 事案一覧取得
 */

export function useGetIncidentsSuspense<
  TData = Awaited<ReturnType<typeof getIncidents>>,
  TError = HTTPValidationError,
>(
  params?: GetIncidentsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getIncidents>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
} {
  const queryOptions = getGetIncidentsSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(
    queryOptions,
    queryClient
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 事案詳細取得
 */
export const getIncident = (incidentId: string, signal?: AbortSignal) => {
  return customInstance<IncidentDetailGetResponse>({
    url: `/incidents/${incidentId}`,
    method: 'GET',
    signal,
  });
};

export const getGetIncidentQueryKey = (incidentId?: string) => {
  return [`/incidents/${incidentId}`] as const;
};

export const getGetIncidentQueryOptions = <
  TData = Awaited<ReturnType<typeof getIncident>>,
  TError = HTTPValidationError,
>(
  incidentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getIncident>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetIncidentQueryKey(incidentId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getIncident>>> = ({
    signal,
  }) => getIncident(incidentId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!incidentId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getIncident>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetIncidentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getIncident>>
>;
export type GetIncidentQueryError = HTTPValidationError;

export function useGetIncident<
  TData = Awaited<ReturnType<typeof getIncident>>,
  TError = HTTPValidationError,
>(
  incidentId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getIncident>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIncident>>,
          TError,
          Awaited<ReturnType<typeof getIncident>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetIncident<
  TData = Awaited<ReturnType<typeof getIncident>>,
  TError = HTTPValidationError,
>(
  incidentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getIncident>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIncident>>,
          TError,
          Awaited<ReturnType<typeof getIncident>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetIncident<
  TData = Awaited<ReturnType<typeof getIncident>>,
  TError = HTTPValidationError,
>(
  incidentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getIncident>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary 事案詳細取得
 */

export function useGetIncident<
  TData = Awaited<ReturnType<typeof getIncident>>,
  TError = HTTPValidationError,
>(
  incidentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getIncident>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetIncidentQueryOptions(incidentId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetIncidentSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getIncident>>,
  TError = HTTPValidationError,
>(
  incidentId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getIncident>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetIncidentQueryKey(incidentId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getIncident>>> = ({
    signal,
  }) => getIncident(incidentId, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getIncident>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetIncidentSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getIncident>>
>;
export type GetIncidentSuspenseQueryError = HTTPValidationError;

export function useGetIncidentSuspense<
  TData = Awaited<ReturnType<typeof getIncident>>,
  TError = HTTPValidationError,
>(
  incidentId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getIncident>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetIncidentSuspense<
  TData = Awaited<ReturnType<typeof getIncident>>,
  TError = HTTPValidationError,
>(
  incidentId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getIncident>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetIncidentSuspense<
  TData = Awaited<ReturnType<typeof getIncident>>,
  TError = HTTPValidationError,
>(
  incidentId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getIncident>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
/**
 * @summary 事案詳細取得
 */

export function useGetIncidentSuspense<
  TData = Awaited<ReturnType<typeof getIncident>>,
  TError = HTTPValidationError,
>(
  incidentId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getIncident>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
} {
  const queryOptions = getGetIncidentSuspenseQueryOptions(incidentId, options);

  const query = useSuspenseQuery(
    queryOptions,
    queryClient
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
